import type { ChallengeObj } from "@/interfaces/vidyaGrid";
import { cn } from "@/lib/utils";

interface ChallengeCellProps {
  challenge: ChallengeObj;
  isCol?: boolean;
}

export default function ChallengeCell({
  challenge,
  isCol,
}: ChallengeCellProps) {
  return (
    <div
      title={challenge.label}
      className={cn(
        [
          "grid",
          "content-center",
          "text-xs 2xl:text-lg",
          "w-[64px]",
          "sm:w-[70px]",
          "2xl:w-[132px]",
          "text-center",
        ],
        { "h-[60px]": isCol }
      )}
    >
      {challenge.label}
    </div>
  );
}
